import { gql, GraphQLClient } from 'graphql-request'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

const query = gql`
  mutation ELIMINAR($id: ID!) {
    recetaEliminar(id: $id)
  }
`
/**
 *
 * @param id ID de la receta a eliminar
 * @returns
 */
export const apiRecetaEliminar = async (id: string): Promise<boolean> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(query, { id })
    return data.recetaEliminar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
